export default {
  0: { name: 'null character' },
  1: { name: 'start of header' },
  2: { name: 'start of text' },
  3: { name: 'end of text' },
  4: { name: 'end of transmission' },
  5: { name: 'enquiry' },
  6: { name: 'acknowledge' },
  7: { name: 'bell (ring)' },
  8: { name: 'backspace' },
  9: { name: 'horizontal tab' },
  10: { name: 'line feed' },
  11: { name: 'vertical tab' },
  12: { name: 'form feed' },
  13: { name: 'carriage return' },
  14: { name: 'shift out' },
  15: { name: 'shift in' },
  16: { name: 'data link escape' },
  17: { name: 'device control 1' },
  18: { name: 'device control 2' },
  19: { name: 'device control 3' },
  20: { name: 'device control 4' },
  21: { name: 'negative acknowledge' },
  22: { name: 'synchronize' },
  23: { name: 'end transmission block' },
  24: { name: 'cancel' },
  25: { name: 'end of medium' },
  26: { name: 'substitute' },
  27: { name: 'escape' },
  28: { name: 'file separator' },
  29: { name: 'group separator' },
  30: { name: 'record separator' },
  31: { name: 'unit separator' },
  32: { name: 'space' },
  33: { name: 'exclamation mark' },
  34: { name: 'quotation mark' },
  35: { name: 'number sign' },
  36: { name: 'dollar sign' },
  37: { name: 'percent sign' },
  38: { name: 'ampersand' },
  39: { name: 'apostrophe' },
  40: { name: 'left parenthesis' },
  41: { name: 'right parenthesis' },
  42: { name: 'asterisk' },
  43: { name: 'plus sign' },
  44: { name: 'comma' },
  45: { name: 'hyphen' },
  46: { name: 'period' },
  47: { name: 'slash' },
  48: { name: 'digit 0' },
  49: { name: 'digit 1' },
  50: { name: 'digit 2' },
  51: { name: 'digit 3' },
  52: { name: 'digit 4' },
  53: { name: 'digit 5' },
  54: { name: 'digit 6' },
  55: { name: 'digit 7' },
  56: { name: 'digit 8' },
  57: { name: 'digit 9' },
  58: { name: 'colon' },
  59: { name: 'semicolon' },
  60: { name: 'less-than' },
  61: { name: 'equals-to' },
  62: { name: 'greater-than' },
  63: { name: 'question mark' },
  64: { name: 'at sign' },
  65: { name: 'uppercase A' },
  66: { name: 'uppercase B' },
  67: { name: 'uppercase C' },
  68: { name: 'uppercase D' },
  69: { name: 'uppercase E' },
  70: { name: 'uppercase F' },
  71: { name: 'uppercase G' },
  72: { name: 'uppercase H' },
  73: { name: 'uppercase I' },
  74: { name: 'uppercase J' },
  75: { name: 'uppercase K' },
  76: { name: 'uppercase L' },
  77: { name: 'uppercase M' },
  78: { name: 'uppercase N' },
  79: { name: 'uppercase O' },
  80: { name: 'uppercase P' },
  81: { name: 'uppercase Q' },
  82: { name: 'uppercase R' },
  83: { name: 'uppercase S' },
  84: { name: 'uppercase T' },
  85: { name: 'uppercase U' },
  86: { name: 'uppercase V' },
  87: { name: 'uppercase W' },
  88: { name: 'uppercase X' },
  89: { name: 'uppercase Y' },
  90: { name: 'uppercase Z' },
  91: { name: 'left square bracket' },
  92: { name: 'backslash' },
  93: { name: 'right square bracket' },
  94: { name: 'caret' },
  95: { name: 'underscore' },
  96: { name: 'grave accent' },
  97: { name: 'lowercase a' },
  98: { name: 'lowercase b' },
  99: { name: 'lowercase c' },
  100: { name: 'lowercase d' },
  101: { name: 'lowercase e' },
  102: { name: 'lowercase f' },
  103: { name: 'lowercase g' },
  104: { name: 'lowercase h' },
  105: { name: 'lowercase i' },
  106: { name: 'lowercase j' },
  107: { name: 'lowercase k' },
  108: { name: 'lowercase l' },
  109: { name: 'lowercase m' },
  110: { name: 'lowercase n' },
  111: { name: 'lowercase o' },
  112: { name: 'lowercase p' },
  113: { name: 'lowercase q' },
  114: { name: 'lowercase r' },
  115: { name: 'lowercase s' },
  116: { name: 'lowercase t' },
  117: { name: 'lowercase u' },
  118: { name: 'lowercase v' },
  119: { name: 'lowercase w' },
  120: { name: 'lowercase x' },
  121: { name: 'lowercase y' },
  122: { name: 'lowercase z' },
  123: { name: 'left curly brace' },
  124: { name: 'vertical bar' },
  125: { name: 'right curly brace' },
  126: { name: 'tilde' },
  127: { name: 'delete (rubout)' }
}
